import request from "superagent";
import { url_endpoint } from "../../config";
import authHeader from "./AuthHeader";

export default async function (adminRoute) {
    return new Promise(async (resolve, reject) => {
        try {
            const res = await request.get(url_endpoint + "cliente/me").set(authHeader())
            const isAdmin = res.body.admin

            if (adminRoute) {
                if ((adminRoute && isAdmin) == false) {
                    window.location.pathname = '/'
                }
                return resolve(res.body)
            } else {
                return resolve(res.body)
            }

        } catch (e) {
            window.location.pathname = '/'
            return resolve(null)
        }
    })
}